import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { IEvent } from 'src/app/shared/models/event';
import { googleMapsLinkValidator } from 'src/app/shared/utils/configuration';

interface DialogData  {
  event: IEvent;
}
@Component({
  selector: 'app-modal-detail-event',
  templateUrl: './modal-detail-event.component.html',
  styleUrls: ['./modal-detail-event.component.scss']
})
export class ModalDetailEventComponent implements OnInit {

  event: IEvent = null;
  imageUrl = '';
  loading = true;
  monthNotifications = 0;
  state = 'view';
  sendNotification = false;
  createForm: FormGroup;

  constructor(public dialogRef: MatDialogRef<ModalDetailEventComponent>,
    public dataService: DataService,
    public matDialog: MatDialog,
    public authService: AuthService,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  async ngOnInit() {

    const monthNotifications = await this.dataService.getNotificationsCountForCurrentMonth(this.authService.userData.brandId);
  
    this.loading = false;
    this.monthNotifications = Math.abs(monthNotifications - this.authService.userData.notificationsPerMonth);

    this.createForm = this.fb.group({
      categories:  [[], Validators.required],
      startDateOfEvent: ['', Validators.required],
      dueDateOfEvent: ['', Validators.required],
      description: ['', Validators.required],
      fullName: ['', Validators.required],
      locationName:  ['', [googleMapsLinkValidator]], 
      availableReservation:  [false],
      image: ['', Validators.required],
      priceRange: ['', Validators.required],
      isOffer: [false],
    });

    this.event = this.data.event;

    this.imageUrl = this.event.image;
    this.loading = false;
  }

  close() {
    this.matDialog.closeAll();
  }

  edit() {
    if (this.state === 'edit') {
      this.state = 'view';
    } else {
      this.state = 'edit';
    }
  }

  getCategoryName(id: string) {
    const category = this.dataService.categories.filter((cat: any) =>  cat.categoryId === id)[0];
    return category.name;
  }

  closeDialog() {
    this.dataService.$eventSaved.emit(true);
  }

}
